import React from 'react';
import { Users, Award, Calendar, CreditCard, ShieldCheck, BarChart } from 'lucide-react';
export function FeatureSection() {
  const features = [{
    icon: <Users className="h-8 w-8 text-primary" data-id="element-174" />,
    title: 'Vendor Management',
    description: 'Digital registration portal, document management, and performance tracking for service providers.'
  }, {
    icon: <Award className="h-8 w-8 text-primary" data-id="element-175" />,
    title: 'Certification System',
    description: 'Digital certificate issuance, training content delivery, and assessment tools.'
  }, {
    icon: <Calendar className="h-8 w-8 text-primary" data-id="element-176" />,
    title: 'Service Booking',
    description: 'Real-time scheduling, instant quotation, and progress tracking with photo documentation.'
  }, {
    icon: <CreditCard className="h-8 w-8 text-primary" data-id="element-177" />,
    title: 'Payment & Financing',
    description: 'Multiple payment options including 3-month 0% installments and secure escrow system.'
  }, {
    icon: <ShieldCheck className="h-8 w-8 text-primary" data-id="element-178" />,
    title: 'Warranty Management',
    description: 'Digital warranty cards, automated expiration alerts, and streamlined claim processing.'
  }, {
    icon: <BarChart className="h-8 w-8 text-primary" data-id="element-179" />,
    title: 'Multi-Stakeholder Dashboards',
    description: 'Specialized interfaces for vendors, customers, and platform administrators.'
  }];
  return <section id="features" className="py-16 bg-white" data-id="element-180">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-181">
        <div className="text-center" data-id="element-182">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl" data-id="element-183">
            Key Platform Features
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-184">
            Comprehensive tools to manage the entire service lifecycle
          </p>
        </div>
        <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3" data-id="element-185">
          {features.map((feature, index) => <div key={index} className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-186">
              <div className="h-14 w-14 rounded-full bg-primary/10 flex items-center justify-center mb-4" data-id="element-187">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-188">
                {feature.title}
              </h3>
              <p className="mt-2 text-gray-600" data-id="element-189">{feature.description}</p>
            </div>)}
        </div>
        <div className="mt-16 text-center" data-id="element-190">
          <button className="px-8 py-3 bg-primary text-white rounded-md text-lg font-medium hover:bg-primary/90 transition-colors" data-id="element-191">
            Explore All Features
          </button>
        </div>
      </div>
    </section>;
}